import { buildSchema,buildProperty } from "@camberi/firecms";

export const onboardingSchema = buildSchema({
    name: "Onboarding",
    properties: {
        header: {
            title: "Header",
            dataType: "string",
            validation: { required: true },
        },
        subHeader: {
            title: "Sub Header",
            dataType: "string",
            config: {
                markdown: true
            },
            validation: { required: true },
        },
        imageRef: buildProperty({
            title: "Image",
            dataType: "reference",
            path: "media",
            previewProperties: ["mediaUrl"],
        }),
        backgroundImage: buildProperty({
            title: "Background Image",
            dataType: "reference",
            path: "media",
            previewProperties: ["mediaUrl"],
        }),
        order: {
            title: "Order",
            dataType: "number",
            validation: { required: true },
        },
        status: {
            title: "status",
            dataType: "boolean"
        },
        createdAt: {
            title: "createdAt",
            dataType: "timestamp",
            validation: { required: true },
        },
    },
    defaultValues: {
        status: false,
        order: 0
    }
});
